import { render } from "./MyMentor.vue?vue&type=template&id=a9a95764&scoped=true"
import script from "./MyMentor.vue?vue&type=script&lang=js"
export * from "./MyMentor.vue?vue&type=script&lang=js"

import "./MyMentor.vue?vue&type=style&index=0&id=a9a95764&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src439103385/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a95764"]])

export default __exports__